(function ($) {
    
    function initImageText() {
        if($('.circle-text').length){
            $('.circle-text').each(function(){
                $(this).circleText({
                    glue: " • ",
                    turn: true,
                    padding: 0,
                    radius: 135,
                    duration: 30,
                    repeat: 1,
                    background: "transparent"
                });
            });
        }
    }
    /* Document Ready */
	$(document).ready(function() {
        initImageText();
	});
    
    // Initialize dynamic block preview (editor).
//    if (window.acf) {
//        window.acf.addAction('render_block_preview/type=image-text', initImageText);
//    }

})(jQuery);